import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { RayForm } from '../../components/common';
import { ModalConfirm } from '../common/ModalConfirm';
import { RayDataAction } from '../../actions/RayDataAction';
import { CompanyAction } from '../../actions/CompanyAction';
import { AlertAction } from '../../actions/AlertAction';
import { WarrantyProductType, WarrantyUPKitModel } from '../../config/RayCodes';
import { Translate as t } from '../../config/Translate';
import { InputBasicDateTime, InputBasicNumber } from '../common/Inputs';
import Loader from "react-loader-spinner";
import { CommonAction } from '../../actions';
import { UserType } from '../../config';
import { ORG_HQ } from '../../config/appConstants';
import { canDeleteRayDataPolicy, resolveRayDataDeleteCategory } from '../../lib/rbacGuard';
import { computeModelOverlaps } from '../../lib/warrantyOverlap';
import { scopeCompaniesForUser } from '../../lib/companyHierarchyService';

// BE(FEAT-044 C-9) 저장 검증 실패 reason → 전용 i18n 키 매핑. 매핑 외/사유 없음은 일반 메시지 폴백.
const WARRANTY_VALIDATION_MSG = {
	WARRANTY_POLICY_STANDARDS_OVERLAP: 'raydata.alert.warrantyOverlap',
	WARRANTY_POLICY_INVALID_DATE_RANGE: 'raydata.alert.warrantyInvalidRange',
	WARRANTY_POLICY_MISSING_DATE: 'raydata.alert.warrantyMissingDate',
};

// FEAT-045 PR4: Add(SEED/APPEND) 겹침 best-effort 스킵 사유 → i18n 키 매핑.
const OVERLAP_REASON_MSG = {
	ALREADY_EXISTS: 'raydata.overlap.reasonAlreadyExists',
	NO_EXISTING: 'raydata.overlap.reasonNoExisting',
	OVERLAP: 'raydata.overlap.reasonOverlap',
};

// IMP-367 (확장): previewSetWarranty excludedDevices[].reason → i18n 키 매핑. 매핑 외 사유는 원문 폴백.
const EXCLUDED_DEVICE_REASON_MSG = {
	NO_DATE: 'raydata.preview.excludedReasonNoDate',
	NO_MATCHING_STANDARD: 'raydata.preview.excludedReasonNoStandard',
};

const RayDataAddUpdate = ({ GetAll, item, items = [], companyList, type, isHQ, data, callbackClose, showModal, Update, Create, Preview, clist }) => {
	const dispatch = useDispatch();
	const user = JSON.parse(localStorage.getItem("user"));

	const [request, setRequest] = useState(false);
	const [val, setVal] = useState({});
	const [companies, setCompanies] = useState([]);
	const [info, setInfo] = useState({});
	const [models, setModels] = useState([]);
	const [delOk, setDelOk] = useState(false);
	const [showConfirm, setShowConfirm] = useState(false);
	const [previewSummary, setPreviewSummary] = useState(null);
	// FEAT-045 PR4: Add(SEED/APPEND) 제출 시 선택 모델별 apply/skip 계획, 확인 후 처리 결과 리포트.
	const [overlapPlan, setOverlapPlan] = useState(null);
	const [applyReport, setApplyReport] = useState(null);
	// FEAT-045: data._id 있으면 EDIT(단일 모델·단일 문서), 없으면 Add 기본 SEED(멀티모델 fan-out).
	const [mode, setMode] = useState(data && data._id ? 'EDIT' : 'SEED');

	useEffect(() => {
		if (data && Object.keys(data).length > 0)
			setInfo({
				_id: data._id,
				companyId: data.companyId,
				models: data.models,
				wartype: data.warrantyType,
				standards : data.standards
			});
		setMode(data && data._id ? 'EDIT' : 'SEED');
		// Minor#2(PR#449 리뷰) — data 변경(재진입) 시 이전 세션의 리포트/미리보기 배너가 남지 않도록 리셋.
		setOverlapPlan(null);
		setPreviewSummary(null);
		setApplyReport(null);
	}, [data])

	const getModelsBig = () => {
		return [...new Set(clist.filter(x => x.type === 'PRODUCTOPTION' && x.category === "Extra-oral Imaging").map(x => x.group))].map(x => ({ code : x, title : x })) ;
	}

	const getModelsSmall = () => {
		return [...new Set(clist.filter(x => x.type === 'PRODUCTOPTION' && x.category !== "Extra-oral Imaging").map(x => x.group))].map(x => ({ code : x, title : x })) ;
	}

	useEffect(() => {
		if (info.wartype == "CT") {
			const filteredModel = user?.isMegagen ? getModelsBig().filter(x => x.code === "R2 Studio Q") : getModelsBig();
			setModels(filteredModel);
		} else if (info.wartype == "UP KIT") {
			setModels(WarrantyUPKitModel);
		} else if (info.wartype == "PRD") {
			const smallDevices = getModelsSmall();
			setModels(smallDevices);
		}
	}, [info])

	// BUG-172: operator(회사) 목록을 접근 가능 clist(본인+하위 서브트리 SSoT, x-ray-clist 동일)
	// 로 스코프. 기존 RAY00001 하드코딩 + 직속 1단계 필터(다단계 미반영) 제거. clist 부재 시
	// fail-closed(헬퍼 내 warn).
	// BUG-173 / PR #460 리뷰 Major#2: HQ 전체노출 특례를 scopeCompaniesForUser SSoT 로 위임하고
	// isHQ prop(AdminRayDataList 가 이미 계산해 내려주는 UserType(user)===ORG_HQ 값)을 재사용한다
	// (컴포넌트 내 UserType 재계산 제거). FE 는 표시(UX)용 스코프이며, 실제 쓰기 권한 경계는
	// BE `assertCompanyWriteScope`(서버 세션 writeScope) 다.
	const setCompanySelect = () => {
		const filtered = scopeCompaniesForUser(companyList, localStorage.getItem('clist'), isHQ, user?.companyId);
		// IMP-370: operator 드롭다운 회사명 오름차순 정렬.
		const cList = filtered.map((c) => ({ code: c.companyId, title: c.name }))
			.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
		setCompanies(cList);
	}

	useEffect(() => {
		if (companyList.length > 0)
			setCompanySelect();
	}, [companyList]);

	// SEED/APPEND(Add) 는 멀티모델 선택(모델당 문서 1개 fan-out), EDIT 는 단일선택(FEAT-044 계약 보존).
	const modelsControlBase = { type: 'select2', name: 'models', label: t('product.field.model'), isEditable: true, required: true, list: models };
	const modelsControl = mode === 'EDIT'
		? { ...modelsControlBase, val: info && (Array.isArray(info.models) ? info.models[0] : info.models) }
		: { ...modelsControlBase, isMulti: true, val: Array.isArray(info.models) ? info.models : (info.models ? [info.models] : []) };

	const war_controls = [{
		title: '', items: [
			{ type: 'select2', name: 'companyId', label: t('user.type.operator'), val: info.companyId, list: companies, isEditable: !info._id },
			{ type: 'select2', name: 'wartype', label: t('warranty.field.warrantyType'), val: info.wartype, list: WarrantyProductType, isEditable: !info._id },
			modelsControl,
		]
	}];

	// mode 별로 선택된 모델 배열을 정규화한다. EDIT 는 항상 단일 원소(또는 빈 배열).
	const getSelectedModels = () => {
		if (mode === 'EDIT') return toSingleModelArr(info.models);
		return Array.isArray(info.models) ? info.models.filter(Boolean) : (info.models ? [info.models] : []);
	};

	useEffect(() => {
		if (showModal)
			setVal({});
		// Minor#2(PR#449 리뷰) — 모달 재오픈 시 이전 세션의 리포트/미리보기 배너가 남지 않도록 리셋.
		setOverlapPlan(null);
		setPreviewSummary(null);
		setApplyReport(null);
	}, [showModal]);

	// select 는 항상 첫 원소만 표시(val=info.models[0])하므로, 저장 payload 도 첫 원소만
	// 담아 화면 표시와 일치시킨다(WYSIWYG). 배열이면 첫 원소, 아니면 값 그대로.
	const toSingleModelArr = (m) => {
		const v = Array.isArray(m) ? m[0] : m;
		return v ? [v] : [];
	};

	// APPEND 매칭과 동일 기준(companyId+wartype+models 포함)으로 기존 문서를 찾는다.
	const findExistingForModel = (model) => items.find(it => Array.isArray(it.models) && it.models.includes(model)
		&& it.companyId === info.companyId
		&& it.wartype === info.wartype);

	// APPEND target 판정 SSoT — computeOverlapPlan(겹침 계산) 과 doSave(실제 Update) 양쪽이
	// 이 헬퍼를 공유해 divergence 를 방지한다(PR4 리뷰 Minor). existing 이 없거나 target
	// category(hqId/branchId, 비병합 문서는 existing.category) 문서 자체가 없으면 null(스킵 대상).
	const resolveAppendTarget = (model, category) => {
		const existing = findExistingForModel(model);
		if (!existing) return null;

		// 병합 항목(hqId/branchId 필드 보유)은 category 별 hqStandards/branchStandards, 비병합
		// 단일 category 항목은 자신의 category 가 일치할 때만 _id/standards 를 사용한다
		// (Blocker#1 — 반대 category 문서를 `|| existing._id` 폴백으로 덮어쓰지 않기 위함).
		const isMergedWarrantyItem = ('hqId' in existing) || ('branchId' in existing);
		const targetId = isMergedWarrantyItem
			? (category === 'HQ' ? existing.hqId : existing.branchId)
			: (existing.category === category ? existing._id : undefined);
		if (!targetId) return null;

		const existingStandards = isMergedWarrantyItem
			? (category === 'HQ' ? existing.hqStandards : existing.branchStandards)
			: existing.standards;

		return { existing, targetId, existingStandards };
	};

	// FEAT-045 PR4: 선택 모델별 apply/skip best-effort 계획을 계산한다(BE validateStandards 는
	// 여전히 최종 방어선). SEED 는 해당 category 문서 존재 여부만으로, APPEND 는 target category
	// 문서 존재 여부(M1) 를 먼저 확인한 뒤 겹침 여부로 판정한다.
	const computeOverlapPlan = (selectedModels, category) => {
		const apply = [];
		const skip = [];

		selectedModels.forEach((model) => {
			if (mode === 'SEED') {
				const existing = findExistingForModel(model);
				const hasCategoryDoc = existing && (category === 'HQ' ? existing.hqId : existing.branchId);
				if (hasCategoryDoc) {
					skip.push({ model, reason: 'ALREADY_EXISTS' });
				} else {
					apply.push(model);
				}
				return;
			}

			// APPEND — [M1] target category 문서가 없으면(반대 category 문서만 존재 포함)
			// doSave 와 동일 기준으로 우선 NO_EXISTING 스킵한다(겹침 검사 생략, silent 누락 방지).
			const target = resolveAppendTarget(model, category);
			if (!target) {
				skip.push({ model, reason: 'NO_EXISTING' });
				return;
			}

			const conflicts = computeModelOverlaps([model], info.standards, { [model]: target.existingStandards || [] })[0]?.conflicts || [];

			if (conflicts.length > 0) {
				skip.push({ model, reason: 'OVERLAP', periods: conflicts });
			} else {
				apply.push(model);
			}
		});

		return { apply, skip };
	};

	const handleSubmit = async () => {
		setRequest(true);
		setApplyReport(null);

		// Minor#1(PR#449 리뷰) — info.standards 무가드 접근으로 인한 TypeError 크래시 방지.
		const stds = Array.isArray(info.standards) ? info.standards : [];

		let invalid = 0;

		stds.forEach(x => {
			const check = ['from', 'to', 'months'];
			check.forEach(y => {
				if (!x.hasOwnProperty(y) || !x[y])
					invalid++;
			})
		});

		if (stds.length === 0 || invalid > 0) {
			dispatch(AlertAction.ErrorMsg(t('raydata.alert.warrantyRequiredFields')));
			setRequest(false);
			return;
		}

		const modelsArr = getSelectedModels();
		if (modelsArr.length === 0) {
			dispatch(AlertAction.ErrorMsg(t('raydata.alert.modelRequired')));
			setRequest(false);
			return;
		}

		const category = isHQ ? 'HQ' : 'BRANCH';

		// FEAT-045 PR4: Add(SEED/APPEND) 는 겹침 plan 을 먼저 계산한다. APPEND 인데
		// companyId/wartype 가 비어있으면 매칭이 무의미하므로(Major#3 가드는 doSave 에서
		// 별도 처리) plan 계산을 건너뛰고 기존 흐름(Preview→확인)으로 진행한다.
		const canComputePlan = mode !== 'EDIT' && !(mode === 'APPEND' && (!info.companyId || !info.wartype));
		let plan = null;
		if (canComputePlan) {
			plan = computeOverlapPlan(modelsArr, category);
			if (plan.apply.length === 0) {
				// IMP-371 — 전부 스킵이어도 alert 로 무음 종료하지 않고 확인 모달을 열어
				// 스킵 사유를 보여준다(Preview 는 적용 대상이 없으므로 호출하지 않는다).
				setPreviewSummary(null);
				setOverlapPlan(plan);
				setShowConfirm(true);
				setRequest(false);
				return;
			}
		}

		// [M2] plan 이 계산됐으면(Add 모드) Preview 도 plan.apply 모델만으로 호출한다 — 스킵
		// 예정 모델을 영향도 계산에 포함시키지 않기 위함(EDIT/plan 미계산 시는 modelsArr 그대로).
		const previewModels = plan ? plan.apply : modelsArr;
		const res = await Preview(type, { ...info, models: previewModels, category });
		setRequest(false);

		if (!res || res.status !== 'success') {
			dispatch(AlertAction.ErrorMsg(t(WARRANTY_VALIDATION_MSG[res?.reason] || 'raydata.preview.failed')));
			return;
		}

		setPreviewSummary(res.data);
		setOverlapPlan(plan);
		setShowConfirm(true);
	}

	const doSave = async () => {
		setRequest(true);
		const category = isHQ ? 'HQ' : 'BRANCH';

		// Major#3 — APPEND 는 companyId/wartype 가 없으면 매칭 조건이 무력화돼 오매칭
		// 위험이 있으므로 저장을 차단한다(silent-drop 금지 — 오류 토스트로 통지).
		if (mode === 'APPEND' && (!info.companyId || !info.wartype)) {
			dispatch(AlertAction.ErrorMsg(t('raydata.alert.appendCompanyWartypeRequired')));
			setShowConfirm(false);
			setRequest(false);
			return;
		}

		if (mode === 'EDIT') {
			const modelsArr = toSingleModelArr(info.models);
			const res = await Update(type, info._id, { ...info, models: modelsArr, category });
			// Major#1(PR#449 리뷰) — 실패 시 성공 흐름(목록 갱신·모달 닫기)으로 진행하지 않는다
			// (허위 성공 통지 금지, preview 실패와 같은 오류 토스트로 통지).
			if (res?.status !== 'success') {
				dispatch(AlertAction.ErrorMsg(t(WARRANTY_VALIDATION_MSG[res?.reason] || 'raydata.preview.failed')));
				setShowConfirm(false);
				setRequest(false);
				return;
			}
		} else if (mode === 'APPEND') {
			// APPEND — plan.apply 모델만 처리(스킵 모델은 매칭 없이 Update 미호출).
			const selectedModels = overlapPlan ? overlapPlan.apply : getSelectedModels();
			const applied = [];
			const failed = [];
			for (const model of selectedModels) {
				// computeOverlapPlan 과 동일한 SSoT 헬퍼로 target 을 판정한다(PR4 리뷰 Minor —
				// divergence 방지). null 이면 매칭되는 기존 문서가 없거나(Create 신규취급 vs 스킵
				// 계약 미확정, appendMerge.feat045.test.js TC2 it.todo) target category(hqId/
				// branchId) 문서 자체가 없는 경우(Blocker#1)이며, 두 경우 모두 silent-drop 금지
				// 원칙에 따라 warn 후 최소 구현으로 스킵한다.
				const target = resolveAppendTarget(model, category);

				if (!target) {
					console.warn('[RayDataAddUpdate] APPEND skip — no matching target category document', {
						handler: 'RayDataAddUpdate.doSave',
						mode,
						model,
						companyId: info.companyId,
						wartype: info.wartype,
						category,
						reason: 'no existing document matched, or no target category document for append',
					});
					continue;
				}

				// Minor#4 — reducer 합성 필드(hqId/branchId/파생 monthsBy* 등)를 그대로 실어보내지
				// 않고, BE update 가 기대하는 필드만 명시적으로 구성한다(EDIT payload 필드셋과 정합).
				const res = await Update(type, target.targetId, {
					companyId: info.companyId,
					category,
					wartype: info.wartype,
					models: [model],
					standards: [...(target.existingStandards || []), ...(info.standards || [])],
				});

				// Major#1(PR#449 리뷰) — fan-out 성공 여부로 집계한다(허위 applied 방지, §7 silent-drop 유사 원칙).
				if (res?.status === 'success') {
					applied.push(model);
				} else {
					failed.push({ model, reason: res?.reason });
				}
			}

			if (overlapPlan) setApplyReport({ applied, skipped: overlapPlan.skip, failed });
		} else {
			// SEED — plan.apply 모델 각각에 대해 모델당 문서 1개로 fan-out 생성(스킵 모델은 Create 미호출).
			const selectedModels = overlapPlan ? overlapPlan.apply : getSelectedModels();
			const applied = [];
			const failed = [];
			for (const model of selectedModels) {
				const res = await Create(type, { ...info, models: [model], category });
				// Major#1(PR#449 리뷰) — fan-out 성공 여부로 집계한다(허위 applied 방지, §7 silent-drop 유사 원칙).
				if (res?.status === 'success') {
					applied.push(model);
				} else {
					failed.push({ model, reason: res?.reason });
				}
			}

			if (overlapPlan) setApplyReport({ applied, skipped: overlapPlan.skip, failed });
		}

		// Major#2 — fan-out(N회 Create/Update) 완료를 reducer item 참조 변경에 위임하지 않고,
		// 모든 작업이 await 완료된 뒤 명시적으로 1회 수행한다(EDIT/SEED/APPEND 공통).
		const companyId = (UserType(user?.companyId, user?.companyInfo?.org) === ORG_HQ) ? '' : user?.companyId;
		GetAll("war", companyId);
		setShowConfirm(false);
		callbackClose();
		setRequest(false);
	}

	const getTitle = () => {
		switch (type) {
			case "war":
				return t(info && info._id ? 'raydata.updateWarrantyStandards' : 'raydata.addWarrantyStandards');
		}
	}

	const updateVal = (e) => {
		const { name, value } = e.target;
		setInfo({ ...info, [name]: value })
	}

	const addRow = (baseDate, type) => {
		const exists = !info.hasOwnProperty('standards') ? [] : info.standards.filter(x => x.baseDate === baseDate && x.type === type);
		const seq = (exists?.length > 0) ? Math.max(...exists.map(x => x.seq)) + 1 : 1;
		
		setInfo({ ...info, standards: [...info.standards || [], { baseDate, type, seq }] });
	}

	const removeRow = (baseDate, type, seq) => {
		setInfo({ ...info, standards: [...info.standards.filter(x => !(x.baseDate === baseDate && x.type === type && x.seq === seq))] });
	}

	const setStandards = (baseDate, type, seq, e) => {
		const standards = info.standards.find(x => x.baseDate === baseDate && x.type === type && x.seq === seq);
		setInfo({
			...info,
			standards: [
				...info.standards.filter(x => !(x.baseDate === baseDate && x.type === type && x.seq === seq)),
				{ ...standards, [e.target.name]: parseInt(e.target.value) }
			]
		});
	}

	const del = async () => {
		if(user){
			// BUG-222: 버튼 렌더 조건과 동일한 판정을 실행 진입부에서 재검증한다(재판정 시점차/직접
			// 호출 방어). 헛클릭 후 실패를 겪지 않도록 delOk 2단계 확인보다 앞에서 차단한다.
			const category = resolveRayDataDeleteCategory(data);
			if (!canDeleteRayDataPolicy({ userType: UserType(user?.companyId, user?.companyInfo?.org), adminType: user?.adminType, category })) {
				console.warn('[RayDataAddUpdate] delete blocked — category/org mismatch or fail-closed', {
					handler: 'RayDataAddUpdate.del',
					callerCompanyId: user?.companyId,
					adminType: user?.adminType,
					targetId: data?._id,
					category,
					reason: 'canDeleteRayDataPolicy rejected',
				});
				return;
			}
			if(!delOk){
				setDelOk(true);
				return;
			}
			await CommonAction.GetRecord({
				data : {
					type : 'warranty',
					delitemid : {
						_id : data._id
					}
				}
			})
	
			const companyId = (UserType(user.companyId, user?.companyInfo?.org) === ORG_HQ) ? '' : user.companyId;
			GetAll("war", companyId);
	
			setDelOk(false); 
			callbackClose();
		}
	}

	return (
		<>
		<Modal show={showModal} onHide={() => { setDelOk(false); callbackClose(); }} size="xl">
			<Modal.Header>
				<h2 className="modal-title">{getTitle()}</h2>
			</Modal.Header>
			<Modal.Body className="p-0">
				{type == "war" &&
					<div className="alert alert-warning m-2 mb-0" role="alert" style={{ fontSize: '13px' }}>
						{t('raydata.notice.bulkWarrantyUpdate')}
					</div>
				}
				{type == "war" && mode !== 'EDIT' &&
					<div className="m-2 mb-0">
						<button
							data-testid="mode-seed"
							aria-pressed={mode === 'SEED'}
							className={mode === 'SEED' ? "btn btn-primary mt-0" : "btn btn-outline-primary mt-0"}
							style={{ marginRight: '5px' }}
							onClick={() => setMode('SEED')}
						>{t('raydata.mode.seed')}</button>
						<button
							data-testid="mode-append"
							aria-pressed={mode === 'APPEND'}
							className={mode === 'APPEND' ? "btn btn-primary mt-0" : "btn btn-outline-primary mt-0"}
							onClick={() => setMode('APPEND')}
						>{t('raydata.mode.append')}</button>
					</div>
				}
				{applyReport &&
					<div data-testid="apply-report" className="alert alert-info m-2 mb-0" style={{ fontSize: '13px' }}>
						<div className="mb-1"><b>{t('raydata.report.title')}</b></div>
						<div data-testid="report-applied">{t('raydata.report.applied')}: {applyReport.applied.join(', ') || '-'}</div>
						<div data-testid="report-skipped">
							{t('raydata.report.skipped')}: {applyReport.skipped.map(s => `${s.model}(${t(OVERLAP_REASON_MSG[s.reason])})`).join(', ') || '-'}
						</div>
						<div data-testid="report-failed">
							{t('raydata.report.failed')}: {(applyReport.failed || []).map(f => f.reason ? `${f.model}(${f.reason})` : f.model).join(', ') || '-'}
						</div>
					</div>
				}
				{type == "war" && <RayForm handleChangeData={updateVal} controls={war_controls} nocard={true} isForm={false} />}

				<div className='p-0 modal-body'>
					<div className='rayform section'>
						<div className='form-group basic'>						
							<div className='p-1'>
								<div style={{ display: 'inline-block', width: '49%', verticalAlign: 'top', marginRight:'14px' }}>
									<div className='d-flex justify-content-between'>
										<label>설치일 기준 제품 보증기간</label>
										<button
											className='btn btn-primary mt-0'
											style={{ fontSize: '13px',  height: '22px', padding: '0 5px', marginLeft: '10px' }}
											onClick={() => addRow('InstalledDate', 'Product')}
										>+{t('common.button.add')}</button>
									</div>
									<div className='w-100'>
									{
										info.standards?.filter(x => x.baseDate === "InstalledDate" && x.type === "Product").length > 0 ? info.standards.filter(x => x.baseDate === "InstalledDate" && x.type === "Product").sort((a, b) => { return a.seq - b.seq }).map((x,idx) => {
											return (
												<div key={`info_${idx}`} className='w-100 d-flex align-items-center'>
													<div style={{ width: '30%', marginRight: '5px' }}>
														<InputBasicDateTime
															options={{ type: "datetime", name: "from", onlyDate: true, val: x.from }}
															editable={true}
															onchange={(e) => setStandards('InstalledDate', 'Product', x.seq, e)} />
													</div>
													<div style={{ width: '30%', marginRight: '5px' }}>
														<InputBasicDateTime
															options={{ type: "datetime", name: "to", onlyDate: true, val: x.to }}
															editable={true}
															onchange={(e) => setStandards('InstalledDate', 'Product', x.seq, e)} />
													</div>
													<div style={{ width: '100px', flexGrow : 1 }}>
														<InputBasicNumber
															options={{ val: x.months || undefined, name: "months", placeholder: "Month(s)", positive: true }}
															editable={true}
															onchange={(e) => setStandards('InstalledDate', 'Product', x.seq, e)}
														/>
													</div>
													<div style={{ verticalAlign: 'middle' }}>
														<a onClick={() => removeRow('InstalledDate', 'Product', x.seq)} style={{ cursor: 'pointer' }}>
															<ion-icon name="remove-circle" style={{ fontSize: '25px', color: 'red', cursor: 'pointer', marginLeft: '3px' }} ></ion-icon>
														</a>
													</div>
												</div>
											)
										}) : <div style={{ marginTop: '10px', fontStyle:'italic' }}>등록된 기준값이 없습니다.</div>
									}
									</div>
									
								</div>
								<div style={{ display: 'inline-block', width: '49%', verticalAlign: 'top' }}>
									<div className='d-flex justify-content-between'>
										<label>설치일 기준 주요파트 보증기간</label>
										<button
											className='btn btn-primary mt-0'
											style={{ fontSize: '13px', height: '22px', padding: '0 5px', marginLeft: '10px' }}
											onClick={() => addRow('InstalledDate', "MainParts")}
										>+{t('common.button.add')}</button>
									</div>
									<div className='w-100'>
									{
										info.standards?.filter(x => x.baseDate === "InstalledDate" && x.type === "MainParts").length > 0 ? info.standards.filter(x => x.baseDate === "InstalledDate" && x.type === "MainParts").sort((a, b) => { return a.seq - b.seq }).map((x, idx) => {
											return (
												<div key={`info2_${idx}`} className='w-100 d-flex align-items-center'>
													<div style={{ width: '30%', marginRight: '5px' }}>
														<InputBasicDateTime
															options={{ type: "datetime", name: "from", onlyDate: true, val: x.from }}
															editable={true}
															onchange={(e) => setStandards('InstalledDate', 'MainParts', x.seq, e)} />
													</div>
													<div style={{ width: '30%', marginRight: '5px' }}>
														<InputBasicDateTime
															options={{ type: "datetime", name: "to", onlyDate: true, val: x.to }}
															editable={true}
															onchange={(e) => setStandards('InstalledDate', 'MainParts', x.seq, e)} />
													</div>
													<div style={{ width: '100px', flexGrow : 1 }}>
														<InputBasicNumber
															options={{ val: x.months || undefined, name: "months", placeholder: "Month(s)", positive: true }}
															editable={true}
															onchange={(e) => setStandards('InstalledDate', 'MainParts', x.seq, e)}
														/>
													</div>
													<div style={{ verticalAlign: 'middle' }}>
														<a onClick={() => removeRow('InstalledDate', 'MainParts', x.seq)} style={{ cursor: 'pointer' }}>
															<ion-icon name="remove-circle" style={{ fontSize: '25px', color: 'red', cursor: 'pointer', marginLeft: '3px' }} ></ion-icon>
														</a>
													</div>
												</div>
											)
										}) : <div style={{ marginTop: '10px', fontStyle:'italic' }}>등록된 기준값이 없습니다.</div>
									}
									</div>
								</div>
								<div style={{ display: 'inline-block', width: '49%', verticalAlign: 'top', marginRight:'14px', marginTop : 14 }}>
									<div className='d-flex justify-content-between'>
										<label>선적일 기준 제품 보증기간</label>
										<button
											className='btn btn-primary mt-0'
											style={{ fontSize: '13px',  height: '22px', padding: '0 5px', marginLeft: '10px' }}
											onClick={() => addRow('ShipmentDate', 'Product')}
										>+{t('common.button.add')}</button>
									</div>
									<div className='w-100'>
									{
										info.standards?.filter(x => x.baseDate === "ShipmentDate" && x.type === "Product").length > 0 ? info.standards.filter(x => x.baseDate === "ShipmentDate" && x.type === "Product").sort((a, b) => { return a.seq - b.seq }).map((x, idx) => {
											return (
												<div key={`info3_${idx}`} className='w-100 d-flex align-items-center'>
													<div style={{ width: '30%', marginRight: '5px' }}>
														<InputBasicDateTime
															options={{ type: "datetime", name: "from", onlyDate: true, val: x.from }}
															editable={true}
															onchange={(e) => setStandards('ShipmentDate', 'Product', x.seq, e)} />
													</div>
													<div style={{ width: '30%', marginRight: '5px' }}>
														<InputBasicDateTime
															options={{ type: "datetime", name: "to", onlyDate: true, val: x.to }}
															editable={true}
															onchange={(e) => setStandards('ShipmentDate', 'Product', x.seq, e)} />
													</div>
													<div style={{ width: '100px', flexGrow : 1 }}>
														<InputBasicNumber
															options={{ val: x.months || undefined, name: "months", placeholder: "Month(s)", positive: true }}
															editable={true}
															onchange={(e) => setStandards('ShipmentDate', 'Product', x.seq, e)}
														/>
													</div>
													<div style={{ verticalAlign: 'middle' }}>
														<a onClick={() => removeRow('ShipmentDate', 'Product', x.seq)} style={{ cursor: 'pointer' }}>
															<ion-icon name="remove-circle" style={{ fontSize: '25px', color: 'red', cursor: 'pointer', marginLeft: '3px' }} ></ion-icon>
														</a>
													</div>
												</div>
											)
										}) : <div style={{ marginTop: '10px', fontStyle:'italic' }}>등록된 기준값이 없습니다.</div>
									}
									</div>
								</div>
								<div style={{ display: 'inline-block', width: '49%', verticalAlign: 'top', marginTop : 14 }}>
									<div className='d-flex justify-content-between'>
										<label>선적일 기준 주요파트 보증기간</label>
										<button
											className='btn btn-primary mt-0'
											style={{ fontSize: '13px', height: '22px', padding: '0 5px', marginLeft: '10px' }}
											onClick={() => addRow('ShipmentDate', "MainParts")}
										>+{t('common.button.add')}</button>
									</div>
									<div className='w-100'>
									{
										info.standards?.filter(x => x.baseDate === "ShipmentDate" && x.type === "MainParts").length > 0 ? info.standards.filter(x => x.baseDate === "ShipmentDate" && x.type === "MainParts").sort((a, b) => { return a.seq - b.seq }).map((x, idx) => {
											return (
												<div key={`info4_${idx}`} className='w-100 d-flex align-items-center'>
													<div style={{ width: '30%', marginRight: '5px' }}>
														<InputBasicDateTime
															options={{ type: "datetime", name: "from", onlyDate: true, val: x.from }}
															editable={true}
															onchange={(e) => setStandards('ShipmentDate', 'MainParts', x.seq, e)} />
													</div>
													<div style={{ width: '30%', marginRight: '5px' }}>
														<InputBasicDateTime
															options={{ type: "datetime", name: "to", onlyDate: true, val: x.to }}
															editable={true}
															onchange={(e) => setStandards('ShipmentDate', 'MainParts', x.seq, e)} />
													</div>
													<div style={{ width: '100px',flexGrow : 1 }}>
														<InputBasicNumber
															options={{ val: x.months || undefined, name: "months", placeholder: "Month(s)", positive: true }}
															editable={true}
															onchange={(e) => setStandards('ShipmentDate', 'MainParts', x.seq, e)}
														/>
													</div>
													<div style={{ verticalAlign: 'middle' }}>
														<a onClick={() => removeRow('ShipmentDate', 'MainParts', x.seq)} style={{ cursor: 'pointer' }}>
															<ion-icon name="remove-circle" style={{ fontSize: '25px', color: 'red', cursor: 'pointer', marginLeft: '3px' }} ></ion-icon>
														</a>
													</div>
												</div>
											)
										}) : <div style={{ marginTop: '10px', fontStyle:'italic' }}>등록된 기준값이 없습니다.</div>
									}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</Modal.Body>
			<Modal.Footer>
				{data._id && canDeleteRayDataPolicy({ userType: UserType(user?.companyId, user?.companyInfo?.org), adminType: user?.adminType, category: resolveRayDataDeleteCategory(data) }) && <button className={"btn btn-block"} style={{ color : 'white', background : 'red'}} onClick={() => {
					del({});
				}}>{delOk ? '정말 삭제요?' : t('common.button.delete')}</button>}
				<button className={request ? "btn btn-block btn-primary disabled" : "btn btn-block btn-primary"} onClick={() => handleSubmit()}>
					{request && <Loader
						type='ThreeDots'
						color='#fff'
						width={30}
						height={30}
						visible={true}
						radius={10}
						style={{ display: 'inline-block', marginRight: '10px' }} />}

					{!request && (info._id ? t('common.button.update') : t('common.button.add'))}
				</button>
				<button className={request ? "btn btn-block btn-dark disabled" : "btn btn-block btn-dark"} onClick={() => {
					setInfo({});
					setDelOk(false); 
					callbackClose();
				}}>{t('common.button.close')}</button>
			</Modal.Footer>
		</Modal>

		<ModalConfirm
			info={{
				showModal: showConfirm,
				title: t('raydata.preview.title'),
				content: (previewSummary || overlapPlan) ? (
					<div
						data-testid="preview-impact-scroll"
						style={{ fontSize: '14px', maxHeight: '60vh', overflowY: 'auto', paddingRight: '6px' }}
					>
						{previewSummary &&
							<>
								<div className="mb-2">{t('raydata.preview.total')}: <b>{previewSummary.total ?? 0}</b></div>
								<ul className="mb-2" style={{ paddingLeft: '18px' }}>
									<li>{t('raydata.preview.newlyApplied')}: {previewSummary.newlyApplied ?? 0}</li>
									<li>{t('raydata.preview.valueChanged')}: {previewSummary.valueChanged ?? 0}</li>
									<li>{t('raydata.preview.warrantyRemoved')}: {previewSummary.warrantyRemoved ?? 0}</li>
									<li>{t('raydata.preview.unchanged')}: {previewSummary.unchanged ?? 0}</li>
									<li>{t('raydata.preview.excludedNoDate')}: {previewSummary.excludedNoDate ?? 0}</li>
									<li>{t('raydata.preview.excludedByCondition')}: {previewSummary.excludedByCondition ?? 0}</li>
								</ul>
								<div className="mb-1"><b>{t('raydata.preview.affected')}: {previewSummary.affected ?? 0}</b></div>
								{(previewSummary.warrantyRemoved ?? 0) > 0 &&
									<div className="alert alert-warning mt-2 mb-0" style={{ fontSize: '13px' }}>{t('raydata.preview.warrantyRemovedWarn')}</div>}
							</>
						}
						{overlapPlan &&
							<div className="mt-2">
								{overlapPlan.apply.length === 0 &&
									<div className="alert alert-warning" data-testid="plan-all-skipped-notice">{t('raydata.overlap.allSkipped')}</div>}
								<div data-testid="plan-apply-count">{t('raydata.overlap.applyCount')}: {overlapPlan.apply.length}</div>
								{overlapPlan.apply.length > 0 &&
									<ul className="mb-2" style={{ paddingLeft: '18px' }} data-testid="plan-apply-list">
										{overlapPlan.apply.map((m, idx) => (
											<li key={idx} data-testid="plan-apply-item">{m}</li>
										))}
									</ul>}
								<div data-testid="plan-skip-count">{t('raydata.overlap.skipCount')}: {overlapPlan.skip.length}</div>
								{overlapPlan.skip.length > 0 &&
									<ul className="mb-0" style={{ paddingLeft: '18px' }}>
										{overlapPlan.skip.map((s, idx) => (
											<li key={idx} data-testid="plan-skip-item">
												{s.model}: {t(OVERLAP_REASON_MSG[s.reason])}
											</li>
										))}
									</ul>}
							</div>
						}
						{Array.isArray(previewSummary?.excludedDevices) && previewSummary.excludedDevices.length > 0 &&
							<div className="mt-2">
								<ul className="mb-0" style={{ paddingLeft: '18px' }} data-testid="excluded-device-list">
									{previewSummary.excludedDevices.map((d, idx) => (
										<li key={idx} data-testid="excluded-device-item">
											{d.sn} · {d.model} · {t(EXCLUDED_DEVICE_REASON_MSG[d.reason] || d.reason)}
										</li>
									))}
								</ul>
							</div>
						}
					</div>
				) : null,
				// IMP-371 — 전부 스킵(apply=0)이면 적용 대상이 없으므로 확인 버튼을 렌더하지 않는다(닫기만 가능).
				actions: (overlapPlan && overlapPlan.apply.length === 0)
					? []
					: [{ title: t('raydata.preview.confirm'), css: 'btn btn-block btn-primary', callback: doSave }],
			}}
			callbackClose={() => setShowConfirm(false)}
		/>
		</>
	);
}

const mapState = (state) => {
	const companyList = state.CompanyReducer.companies;
	const item = state.RayDataReducer.item;
	const items = state.RayDataReducer.items;
	const clist = state.RayCodeReducer.items;
	return { item, items, companyList, clist };
};

const mapDispatch = (dispatch) => ({
	//GetCompany: () => dispatch(CompanyAction.GetCompany()),
	GetAll: (dataType, companyId) => dispatch(RayDataAction.GetAll(dataType, companyId)),
	Update: (type, _id, info) => dispatch(RayDataAction.Update(type, _id, info)),
	Create: (type, info) => dispatch(RayDataAction.Create(type, info)),
	Preview: (type, info) => RayDataAction.Preview(type, info),
});

export default connect(mapState, mapDispatch)(RayDataAddUpdate);
